import React from 'react';
import PropTypes from 'prop-types';

import GoogleLogo from '../../../images/icons/partner-logo-google.svg';

const GoogleSignupCta = ({ googleSignupBaseUrl, googleButtonLabel }) => (
  <a
    className="d-flex align-items-center justify-content-center btn btn-secondary google-btn"
    href={googleSignupBaseUrl}
  >
    <img alt="Google Logo" className="img-square-20px" src={GoogleLogo} />
    <strong className="padding-left-5px">{googleButtonLabel}</strong>
  </a>
);

GoogleSignupCta.propTypes = {
  googleSignupBaseUrl: PropTypes.string.isRequired,
  googleButtonLabel: PropTypes.string,
};

GoogleSignupCta.defaultProps = {
  googleButtonLabel: 'Continue with Google',
};

export default GoogleSignupCta;
